import {Component, Input} from "@angular/core";
import {AvdbType} from "../avdb-type";

@Component({
	selector: "avdb-type-logo",
	template: `
		<img *ngIf="avdbType.logoURL; else text" [src]="avdbType.logoURL" />
		<ng-template #text>{{avdbType.name}}</ng-template>
	`,
	styles: [`
		img {
			height: 1.33em;
			vertical-align: -0.3em;
		}
	`],
})
export class AvdbTypeLogoComponent {
	@Input() avdbType: AvdbType;
}
